export default __webpack_public_path__ + "static/media/iconWhite.28b294dd.png";